import {useNavigate, useSearchParams} from "react-router-dom";
import {permissionSelector, useGetPermissionQuery} from "@ots-frontend/ots-data";
import {skipToken} from "@reduxjs/toolkit/query";
import {useMemo} from "react";
import {useTranslation} from "react-i18next";
import {ErrorPage} from "../../components/page/ErrorPage/ErrorPage";
import {PermissionProfile} from "../../components/profile/PermissionProfile/PermissionProfile";
import {EntityProfilePage} from "../EntityProfilePage/EntityProfilePage";

type Props = {
  id?: string;
}

export const PermissionProfilePageRoute = () => {
  const [params, _setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const {t} = useTranslation()

  const id = params.get("id") ?? undefined;

  if (!id) {
    navigate(-1);
    return (
      <ErrorPage
        message={t("common.entity.permission", "Permission") + " " + t("common.error.notfound", "Not Found")}/>
    );
  }

  return <PermissionProfilePage id={id}/>;
};

export const PermissionProfilePage = (props: Props) => {
  const {id} = props;

  const selectPermission = useMemo(() => {
    return permissionSelector()
  }, []);

  const {permission, isFetching} = useGetPermissionQuery(id ?? skipToken, {
    selectFromResult: (result) => ({
      permission: selectPermission(result),
      isFetching: result.isFetching
    })
  });

  return (
    <EntityProfilePage permissions={["permission_view"]} entity={permission} isLoading={isFetching}>
      {(entity) => (
        <PermissionProfile permission={entity}/>
      )}
    </EntityProfilePage>
  )
};
